import { useMemoize } from '@vueuse/core'
import { getXihePreviewVideo } from '~/api/module/record'
interface TextData {
  alpha: number
  color: string
  fontFamily: string
  fontSize: number
  height: number
  rotation: number
  scale: number
  text: string
  textAlign: string
  type: string
  width: number
  x: number
  y: number
}

interface ICaptionItem {
  hide_time: number
  show_time: number
  metadata: TextData
}

export const useVideoSubtitle = useMemoize(
  async (generate_record_id: number) => {
    const res = await getXihePreviewVideo({ generate_record_id })
    const caption_info: ICaptionItem[] = []
    const { timelineFPS = 0, rows = [] } = res.data?.video_config || {}

    const track_caption_obj = rows.find(
      (_: any) => _.type === 'track_caption'
    ) || { children: [] }

    track_caption_obj.children.forEach((_: any) => {
      const track_caption_info = {
        metadata: _.data.children[0],
        show_time: _.trigger / timelineFPS,
        hide_time: (_.trigger + _.duration) / timelineFPS,
      }
      caption_info.push(track_caption_info)
    })

    return caption_info
  }
)
